import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-index", "onClick"]
const _hoisted_2 = { class: "gameTitle" }
const _hoisted_3 = {
  key: 0,
  class: "tag"
}
const _hoisted_4 = { class: "tagTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "games-container",
    name: "game",
    appear: "",
    onBeforeEnter: _cache[0] || (_cache[0] = (e) => _ctx.beforeEnter(<HTMLElement>e)),
    onEnter: _cache[1] || (_cache[1] = (e, done) => _ctx.enter(<HTMLElement>e, done))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayGames, (game, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "game",
        "data-index": index,
        style: _normalizeStyle({'background-image':'url('+game.getImageUrl()+')'}),
        onClick: ($event: any) => (_ctx.selectGame(game))
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(game.name), 1),
        (game.tag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(game.tag), 1)
            ]))
          : _createCommentVNode("", true)
      ], 12, _hoisted_1))
    }), 128))
  ], 32))
}